import { render, staticRenderFns } from "./TrgovinskiLanci.vue?vue&type=template&id=79937b61&scoped=true&"
import script from "./TrgovinskiLanci.vue?vue&type=script&lang=ts&"
export * from "./TrgovinskiLanci.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79937b61",
  null
  
)

export default component.exports